// extracted by mini-css-extract-plugin
export default {"cart":"CartIcon_cart__HhZxW","cartIcon":"CartIcon_cartIcon__j1LqO","cartAmount":"CartIcon_cartAmount__ZXrMu","bump":"CartIcon_bump__BNPm4"};